<script lang="ts">
  interface Props {
    children?: import("svelte").Snippet;
  }

  let { children }: Props = $props();
</script>

<span class="text-[var(--primary-strong)]">{@render children?.()}</span>
